/**
 * Role-based routing utilities
 * Provides helper functions to determine default routes based on user roles
 */

import { ERoleType } from '@/features/user-management/constants'
import { RoleWithScopes } from '@/schema'

import { ROUTES } from './routes'

/**
 * Get the default landing route for a user based on their role
 * @param roles - Array of user roles
 * @returns Default route path for the user
 */
export const getDefaultRouteForRole = (
  roles: RoleWithScopes[] = []
): string => {
  const roleNames = new Set(roles.map((r) => r.role_name))

  // OrgAdmin and ProjectLead default to Dashboard
  if (
    roleNames.has(ERoleType.ORGANIZATION_ADMIN) ||
    roleNames.has(ERoleType.PROJECT_LEAD)
  ) {
    return ROUTES.DASHBOARD
  }

  // TeamMember defaults to Deliverable Set
  if (roleNames.has(ERoleType.TEAM_MEMBER)) {
    return ROUTES.DELIVERABLE_SET
  }

  // Reviewer and Viewer default to My Queue (My Work)
  if (roleNames.has(ERoleType.REVIEWER) || roleNames.has(ERoleType.VIEWER)) {
    return ROUTES.MY_WORK
  }

  // Fallback to Dashboard for unknown roles
  return ROUTES.DASHBOARD
}

export const isUserHasPermissionInProject = (
  listProjectId: string[],
  projectId: string
): boolean => {
  return listProjectId.includes(projectId)
}

export const isUserHasPermissionDeliverableSet = (
  listCompanyId: string[],
  companyId: string
): boolean => {
  return listCompanyId.includes(companyId)
}
